import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned four things today 8.9.",
  "description": "",
  "published": "2011-09-08T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-four-things-today-8-9/swizec/2395"],
  "categories": "And God Created Woman, Brigitte Bardot, Learning, PayPal, Personal, Scarlett Johansson, Spotify",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/09/300px-Brigitte_Bardot3.jpg",
        "alt": "Brigitte Bardot à un cocktail en 1968",
        "title": "Brigitte Bardot à un cocktail en 1968"
      }}></img></p>
    <p>{`Because I was learning ... well rather studying ... a bunch of silly stuff yesterday I have decided to write about the four things I learned today. Some of these might technically have happened yesterday, but who cares.`}</p>
    <ol>
      <li parentName="ol">{`I learned that my old sleep tactic for studying all night has been sucky. I used to stay up all night, then at about 7am would have trouble even staying awake, let alone having the presence of mind to do well on an exam usually happening around 10am. And I often fell asleep on the sofa at these early morning hours only to barely make it to the exam in the first place.`}</li>
    </ol>
    <p>{`The new tactic is going to bed in the evening, waking up at midnight or around 1am. You're still studying all night, but at least you got some sleep in you. It worked pretty well ... whether I passed the exam is still to be found out.`}</p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">
        <p parentName="li">{`After the exam I was pretty sleepy and practically collapsed in front of the television. Before I dozed off I caught a few glimpses of a documentary about Brigitte Bordot. She was this super hot actress with a career peek in the 50's and 60's. Apparently she starred in a movie with the longest bed scene ever - a whopping 35 minutes! Didn't quite catch the title, but my best internet informants tell me it might be `}<a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/And_God_Created_Woman_%281956_film%29",
            "title": "And God Created Woman (1956 film)"
          }}>{`And God Created Woman`}</a>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Unlike what I had previously thought, `}<a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Spotify",
            "title": "Spotify"
          }}>{`Spotify`}</a>{` seems to work in `}<a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Europe",
            "title": "Europe"
          }}>{`Europe`}</a>{` anyway. I might still be under some sort of travel grace period, but we'll see what happens in a couple of days. Shame I can't use it on my main linux box or the iphone because some of those playlists are to die for. I would hate being forced to recreating them on my own.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Apparently it is possible for a European to rather easily get an american credit card. Moneybookers is a service quite like `}<a parentName="p" {...{
            "href": "http://paypal.com",
            "title": "PayPal"
          }}>{`PayPal`}</a>{`, but with a very important upside - the credit card. From what I can understand this could make my internet life a whole lot easier and I might actually be able to legally use iPhone apps like a proper person!`}</p>
      </li>
    </ol>
    <p>{`But we'll see how hard it is to actually get the card.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.iqtell.com/2011/08/how-to-survive-your-college-exams/"
        }}>{`How to Survive Your College Exams | Manage your tasks, emails, bookmarks and much more on IQTELL`}</a>{` (iqtell.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.eonline.com/news/the_awful_truth/tuned_in_tone_deaf_scarlett_johansson/262251?cmpid=rss-000000-rssfeed-365-topstories"
        }}>{`Tuned In or Tone Deaf? Scarlett Johansson Sings Her Best Brigitte Bardot`}</a>{` (eonline.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.trendhunter.com/trends/mike-lewis-1972"
        }}>{`Voluminous Hair Photoshoots - The Mike Lewis 1972 Spread Stars a Brigitte Bardot Lookalike (TrendHunter.com)`}</a>{` (trendhunter.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=a0ee10eb-1c0e-4a80-850f-709b7001ab39",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      